var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header b_white" }, [
    _c("div", { staticClass: "b_gray2" }, [
      _c("div", { staticClass: "w1370 f12 st" }, [
        _c("div", { staticClass: "d_top clear row clearfix" }, [
          _c("a", { staticClass: "gray_6", attrs: { href: "" + _vm.app } }, [
            _vm._v("农信商城首页")
          ]),
          _c("span", { staticClass: "pad15_l gray_6" }, [
            _vm._v("商城客服：400-810-5353")
          ]),
          _c(
            "ul",
            { staticClass: "float-right f12" },
            [
              _vm.userInfo.id
                ? [
                    _c("li", {
                      staticClass: "user-info-panel",
                      attrs: { id: "user" }
                    }),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 yahei black",
                          attrs: { href: _vm.logOut + "/logout.do" }
                        },
                        [_vm._v("退出")]
                      )
                    ])
                  ]
                : [
                    _c("li", { staticClass: "d_lg" }, [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: { href: _vm.app + "login.do" }
                        },
                        [_vm._v("请登录")]
                      )
                    ]),
                    _c("li", { staticClass: "d_zc" }, [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: { href: _vm.passport + "register.html" }
                        },
                        [_vm._v("免费注册")]
                      )
                    ])
                  ],
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "gray_6",
                    attrs: { href: _vm.app + "login.do" }
                  },
                  [_vm._v("我的商城")]
                ),
                _c("i", {
                  staticClass: "iconfont icon-weibiaoti1fuzhi04 gray_6 f10"
                }),
                _c("div", { staticClass: "z_user w182 clearfix" }, [
                  _c("ul", { staticClass: "float-left" }, [
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: { href: _vm.app + "order/person/orderList.do" }
                        },
                        [_vm._v("我的订单")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: { href: _vm.app + "recommend/page.do" }
                        },
                        [_vm._v("采购订货")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: {
                            href: _vm.app + "payment/margin/myMargin.do"
                          }
                        },
                        [_vm._v("我的余额")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: {
                            href: _vm.app + "member/favorite/listPage.do"
                          }
                        },
                        [_vm._v("我的收藏")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: { href: _vm.app + "bill/page.do" }
                        },
                        [_vm._v("账单")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: { href: _vm.app + "v/buyer/receive" }
                        },
                        [_vm._v("地址信息")]
                      )
                    ])
                  ])
                ])
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "f12 st gray_6",
                    attrs: { href: _vm.app + "login.do" }
                  },
                  [_vm._v("卖家中心")]
                ),
                _c("i", {
                  staticClass: "iconfont icon-weibiaoti1fuzhi04 gray_6"
                })
              ]),
              _c("li", [
                _c("a", { staticClass: "f12 gray_6", attrs: { href: "#" } }, [
                  _vm._v("客户服务")
                ]),
                _c("i", {
                  staticClass: "iconfont icon-weibiaoti1fuzhi04 gray_6"
                }),
                _c("div", { staticClass: "z_user w92" }, [
                  _c("ul", [
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: { href: _vm.passport + "register.html" }
                        },
                        [_vm._v("用户注册")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: {
                            href:
                              _vm.app +
                              "goods/tofootindex/shoppingprocessGuide.do"
                          }
                        },
                        [_vm._v("购物流程")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: {
                            href: _vm.app + "goods/tofootindex/processEnter.do"
                          }
                        },
                        [_vm._v("商家入驻")]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "f12 gray_6",
                          attrs: {
                            href:
                              _vm.app +
                              "goods/tofootindex/commonproblemGuide.do"
                          }
                        },
                        [_vm._v("常见问题")]
                      )
                    ])
                  ])
                ])
              ])
            ],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }